import React, { useState, useEffect } from 'react';
// import styles from './BasicInfo.module.scss';
import { Container, Row, Col } from 'react-bootstrap';
import TextInput from '../TextInput/TextInput';
import Dropdown from '../Dropdown/Dropdown';
import { stateOptions } from '../Dropdown/stateOptions';
import { ErrorMessage } from 'formik';
import styles from '../../../../views/CCH-Timesheet/CCH-Timesheet.module.scss';

export type BasicInfoProps = {
  infoData: any;
  errors?: any;
  touched?: any;
  handleChange?: any;
  handleBlur?: any;
  values?: any;
  isSubmitting?: boolean;
};

const BasicInfo = ({ infoData, errors, touched, handleChange, handleBlur, values, isSubmitting }: BasicInfoProps,) => {

  const [stateSelection, setStateSelection] = useState();
  const [employeeFirstName, setEmployeeNameFirstName] = useState();
  const [employeeLastName, setEmployeeNameLastName] = useState();
  const [unit, setUnit] = useState();
  const [facility, setFacility] = useState();
  const [ssn, setSSN] = useState();
  const [email, setEmail] = useState('');

  useEffect(() => {
    infoData({
      state: stateSelection,
      employeeFirstName: employeeFirstName,
      employeeLastName: employeeLastName,
      unit: unit,
      facility: facility,
      last5SSN: ssn,
      email: email.trim(),
    });
    // eslint-disable-next-line
  }, [
    stateSelection,
    employeeFirstName,
    employeeLastName,
    unit,
    facility,
    ssn,
    email,
  ]);

  return (
    <Container data-testid="BasicInfo">
      <Row>
        <Col xs={6} md={6} lg={6}>
          <Dropdown
            name='state'
            title="What State Are You Working?"
            required
            onValueChange={setStateSelection}
            options={stateOptions}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values.state}
            isFieldInvalid={isSubmitting && errors.state ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="state" >
            {msg => <p style={{ color: 'red',fontSize:12 }}>{msg}</p>}
          </ErrorMessage>        </Col>
      </Row>
      <Row>
        <Col>
          <TextInput
            title="Unit"
            required
            onValueChange={setUnit}
            name="unit"
            fieldValidation="required"
            values={values.unit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            isFieldInvalid={isSubmitting && errors.unit ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="unit" >
            {msg => <p style={{ color: 'red' ,fontSize:12 }}>{msg}</p>}
          </ErrorMessage>
        </Col>
        <Col>
          <TextInput
            title="Client/Facility Name"
            required
            onValueChange={setFacility}
            name="clientName"
            fieldValidation="required"
            values={values.clientName}
            handleBlur={handleBlur}
            handleChange={handleChange}
            isFieldInvalid={isSubmitting && errors.clientName ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="clientName" >
            {msg => <p style={{ color: 'red',fontSize:12 }}>{msg}</p>}
          </ErrorMessage>        </Col>
        <Col>
          <TextInput
            title="Employee First Name"
            required
            onValueChange={setEmployeeNameFirstName}
            name="firstName"
            fieldValidation="required"
            values={values.firstName}
            handleBlur={handleBlur}
            handleChange={handleChange}
            isFieldInvalid={isSubmitting && errors.firstName ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="firstName" >
            {msg => <p style={{ color: 'red',fontSize:12 }}>{msg}</p>}
          </ErrorMessage>        </Col>
      </Row>
      <Row>
        <Col >
          <TextInput
            title="Employee Last Name"
            required
            onValueChange={setEmployeeNameLastName}
            name="lastName"
            fieldValidation="required"
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values.lastname}
            isFieldInvalid={isSubmitting && errors.lastName ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="lastName" >
            {msg => <p style={{ color: 'red',fontSize:12 }}>{msg}</p>}
          </ErrorMessage>        </Col>
        <Col >
          <TextInput
            title="Last 5 Digits of SSN"
            required
            onValueChange={setSSN}
            name="ssn"
            fieldValidation="ssn"
            pattern="\d*"
            type={'text'}
            inputMode={'numeric'}
            values={ssn}
            handleBlur={handleBlur}
            handleChange={handleChange}
            isFieldInvalid={isSubmitting && errors.ssn ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="ssn" >
            {msg => <p style={{ color: 'red',fontSize:12 }}>{msg}</p>}
          </ErrorMessage>        </Col>
        <Col >
          <TextInput
            title="Email"
            required
            onValueChange={setEmail}
            placeholder={'example@example.com'}
            name="email"
            fieldValidation="email"
            type={'email'}
            value={email}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values.email.trim()}
            isFieldInvalid={isSubmitting && errors.email ? true : false}
          />
          <ErrorMessage className={styles.ErrorMessageNotice} name="email" >
            {msg => <p style={{ color: 'red',fontSize:12 }}>{msg}</p>}
          </ErrorMessage>        </Col>
      </Row>
    </Container>
  );
};

export default BasicInfo;
